import { BasicObject } from './basicObject';

// all basic buttons "animate" (i.e. change color) when clicked
// and have a mouseMoveResponse to change the cursor
export function getBasicButton($canvas: JQuery<HTMLElement>): BasicObject {
  const button = new BasicObject();

  button.gmmName = 'basic button';

  button.animates = true;

  button.mouseMoveResponse = function () {
    if (this.mouseIsOver) {
      // set cursor as pointer to show button is clickable
      $canvas.css('cursor', 'pointer');
    } else {
      // reset cursor to default when not over a button
      $canvas.css('cursor', 'default');
    }
  };

  button.repaintOnMouseOver = function () {
    return false;
  };

  return button;
}
